// api/authAPI.ts

import apiClient from './apiClient';

export const loginApi = async ({
  email,
  password,
  device
}:{
  email: string,
  password: string,
  device: any
}) => apiClient.post('/api/auth/login', { email, password, token: true, device });

export const logoutApi = async () => apiClient.post('/api/auth/logout', { refreshToken: localStorage.getItem('refreshToken'), accessToken: localStorage.getItem('accessToken')});
